(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-accordion-service"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {

  /* ── Click manual del usuario en la cabecera ── */
  document.querySelectorAll('.cart-accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item  = trigger.closest('.cart-accordion__item');
      const index = parseInt(item.dataset.accordionIndex);
      window.AccordionAPI?.toggle(item, index);
    });
  });

  /* ── AccordionAPI global ───────────────────────────────────────
     Expuesto en window para que StepperAPI (cart-summary.liquid)
     pueda llamar AccordionAPI.open(index) desde fuera del snippet.
     
     CLAVE: open() cierra todos los hermanos y abre solo el item
     con data-accordion-index === index, dentro del scope indicado.
     Esto permite que el StepperAPI navegue entre pasos sin
     re-renderizar el acordeón.                                    */
  window.AccordionAPI = {

    /* Abre un ítem por índice (1-based).
       Si no se pasa container, busca en todo el documento. */
    open(index, container) {
      const scope = container || document;
      const item  = scope.querySelector(`.cart-accordion__item[data-accordion-index="${index}"]`);
      if (!item) {
        console.warn('[AccordionAPI] No se encontró item con índice', index, 'en el scope', scope);
        return;
      }
      this._openItem(item, index);
    },

    /* Cierra todos los hermanos y abre el ítem indicado */
    _openItem(item, index) {
      /* Cerrar hermanos del mismo acordeón */
      const siblings = item.closest('.cart-accordion')
        ?.querySelectorAll('.cart-accordion__item');
      siblings?.forEach(sib => {
        if (sib !== item) this._close(sib);
      });

      const wasOpen = item.classList.contains('cart-accordion__item--open');
      if (wasOpen) return; /* ya estaba abierto — no re-init */

      /* Abrir */
      item.classList.add('cart-accordion__item--open');
      const trigger = item.querySelector('[data-accordion-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');

      /* Notificar al bus DESPUÉS del repaint para que
         grid-template-rows ya esté expandido cuando
         corran los módulos de contenido.               */
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (window.CartBus) {
            window.CartBus.emit('accordion:open', { index, item });
          }
        });
      });
    },

    toggle(item, index) {
      if (item.classList.contains('cart-accordion__item--open')) {
        this._close(item);
      } else {
        this._openItem(item, index);
      }
    },

    _close(item) {
      item.classList.remove('cart-accordion__item--open');
      const trigger = item.querySelector('[data-accordion-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  };

});
  } catch(e) { console.error(e); }
})();

})();
